

/*


  What default characters do we need ?
  Start details such x, y, timing ....
  (Multiple) center points such as x, y, timing ...
  End details such as x, y, timing ...

  Will require min(x, y) and max(x, y) for stripping white space

  default functions
  paint()

*/

class Core {
  //#details;
  #paths;
  #min;
  #max;
  constructor(props) {
    if( props.toUpperCase ) props.text = props.text.toUpperCase();
    this.details = props;
    this.paths = [];
    this.min = [1280, 720];
    this.max = [0, 0];
  }

  wordwrap( str, width, cut ) {
    width = width || 75;
    cut = cut || false;
    if (!str) { return str; }
    let regex = '.{1,' +width+ '}(\\s|$)' + (cut ? '|.{' +width+ '}|.+$' : '|\\S+?(\\s|$)');
    console.log(regex);
    return str.match( RegExp(regex, 'g') );
  }

  Min(x, y) {
    //let min = this.min;
    if( x < this.min[0] ) this.min[0] = x;
    if( y < this.min[1] ) this.min[1] = y;
    //this.
  }

  Max(x, y) {
    if( x > this.max[0] ) this.max[0] = x;
    if( y > this.max[1] ) this.max[1] = y;
  }
  
  easeInBounce(x) {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) {
    return n1 * x * x;
    } else if (x < 2 / d1) {
        return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
        return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
        return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
  }

  easeOutBounce(x) {
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) {
    return n1 * x * x;
    } else if (x < 2 / d1) {
        return n1 * (x -= 1.5 / d1) * x + 0.75;
    } else if (x < 2.5 / d1) {
        return n1 * (x -= 2.25 / d1) * x + 0.9375;
    } else {
        return n1 * (x -= 2.625 / d1) * x + 0.984375;
    }
  }

  Transition(fps, path) {
    let x = (fps.current - path.begin) / (path.duration-path.begin);
    switch(path.method) {
      case 'easeIn':
        return Math.cos(((1 - x) * Math.PI) / 2);
      case 'easeOut':
        return 1 - Math.sin(((1 - x) * Math.PI) / 2);
      case 'easeInElastic':
        const c4 = (2 * Math.PI) / 3;
        return x === 0
          ? 0
          : x === 1
          ? 1
          : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
      case 'easeInOutElastic':
        const c5 = (2 * Math.PI) / 4.5;
        return x === 0
          ? 0
          : x === 1
          ? 1
          : x < 0.5
            ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * c5)) / 2
            : (Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * c5)) / 2 + 1;
      case 'easeInOutQuad':
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
      case 'easeInOutCubic':
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
      case 'easeInOutQuint':
        return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
      case 'easeInOutExpo':
        return x === 0
          ? 0
          : x === 1
          ? 1
          : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2
          : (2 - Math.pow(2, -20 * x + 10)) / 2;
      case 'easeInOutCirc':
        return x < 0.5
          ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2
          : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
      case 'easeInBounce':
        return this.easeInBounce(x);
      case 'easeOutBounce':
        return 1 - this.easeInBounce(1-x);
      case 'easeInOutBounce':
        return x < 0.5
          ? (1 - this.easeOutBounce(1 - 2 * x)) / 2
          : (1 + this.easeOutBounce(2 * x - 1)) / 2;
      default:
        return ((fps.current - path.begin) % (path.duration-path.begin)) / (path.duration-path.begin);
    }
  }
  
}



//---- Typography

export class Typography1 extends Core {
  constructor(props) {
    super(props);
  }

  load(canvas, fps) {

    //`M${canvas.width/4},${canvas.height/2} ${canvas.width/2},${canvas.height/2}`

    this.paths.push({
      path: `M${canvas.width/4},${canvas.height/2} ${canvas.width/2},${canvas.height/2}`,
      method: 'easeInOutBounce',
      duration: this.details.timeline[1] / 100 * fps.duration,
      begin: this.details.timeline[0] / 100 * fps.duration
    }, {
      path: `M${canvas.width/2},${canvas.height/2} ${canvas.width/2},${canvas.height/2}`,
      duration: this.details.timeline[2] / 100 * fps.duration,
      begin: this.details.timeline[1] / 100 * fps.duration
    }, {
      path: `M${canvas.width/2},${canvas.height/2} ${canvas.width/4*3},${canvas.height/2}`,
      method: 'easeInOutBounce',
      duration: this.details.timeline[3] / 100 * fps.duration,
      begin: this.details.timeline[2] / 100 * fps.duration
    });

    for( let i in this.paths) {
      this.paths[i].pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
      this.paths[i].pathEl.setAttribute("d", this.paths[i].path);
      this.paths[i].path2d = new Path2D(this.paths[i].path);
      
    }

    
  }


  paint(ctx, fps) {
    for( let i in this.paths ) {
      if( fps.current >= this.paths[i].begin && fps.current < this.paths[i].duration ) {
        //ctx.stroke(this.paths[i].path2d);

        //---- Which method ?
        let delta = this.Transition(fps, this.paths[i]); //0;
        switch(this.paths[i].method) {
          case 'easeIn': case 'easeInElastic':
            //ctx.globalAlpha = delta;
          break;
          case 'easeOut':
            //ctx.globalAlpha = 1 - delta;
          break;
          default:
            //delta = ((fps.current - this.paths[i].begin) % (this.paths[i].duration-this.paths[i].begin)) / (this.paths[i].duration-this.paths[i].begin);
            //ctx.globalAlpha = 1;
          break;

        }

        
        let distance = delta * this.paths[i].pathEl.getTotalLength();
        let pt = this.paths[i].pathEl.getPointAtLength(distance);



        let tempString = this.details.text, metrics = ctx.measureText(tempString );
        ctx.font = `${this.details.fontSize}px ${this.details.fontFamily}`; //"16px serif";
        ctx.fillText(this.details.text, pt.x - (metrics.width/2), pt.y + (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);
        this.Min(pt.x - (metrics.width/2), pt.y - (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);
        this.Max(pt.x + (metrics.width/2), pt.y + (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);

        //this.box(ctx, fps);
      }
    }
    return {min: this.min, max: this.max};
  }
}


export class TypographyShadow extends Core {
  constructor(props) {
    super(props);

    //---- Adjust text details
    if( typeof this.details.text === 'string' ) {
      this.details.text = this.wordwrap(this.details.text, Math.round(this.details.text.length / 3) + 3, '' );
      for( let i in this.details.text ) this.details.text[i] = this.details.text[i].replace(/^\s+|\s+$/g, '');
      console.log(this.details.text);
    }

    //---- Admentments

    //console.log(this.details);
    

  }

  load(canvas, fps) {

    for( let i in this.details.text ) {
      
      console.log((parseInt(i)-(this.details.text.length-1)/2)*this.details.fontSize);
      let y = (parseInt(i)-(this.details.text.length-1)/2)*this.details.fontSize;

      this.paths.push({
        path: `M${canvas.width/4},${canvas.height/2+y} ${canvas.width/2},${canvas.height/2+y}`,
        method: 'easeInOutBounce',
        duration: this.details.timeline[1] / 100 * fps.duration,
        begin: this.details.timeline[0] / 100 * fps.duration,
        text: this.details.text[i]
      }, {
        path: `M${canvas.width/2},${canvas.height/2+y} ${canvas.width/2},${canvas.height/2+y}`,
        duration: this.details.timeline[2] / 100 * fps.duration,
        begin: this.details.timeline[1] / 100 * fps.duration,
        text: this.details.text[i]
      }, {
        path: `M${canvas.width/2},${canvas.height/2+y} ${canvas.width/4*3},${canvas.height/2+y}`,
        method: 'easeInOutBounce',
        duration: this.details.timeline[3] / 100 * fps.duration,
        begin: this.details.timeline[2] / 100 * fps.duration,
        text: this.details.text[i]
      });

      for( let i in this.paths) {
        this.paths[i].pathEl = document.createElementNS("http://www.w3.org/2000/svg", "path");
        this.paths[i].pathEl.setAttribute("d", this.paths[i].path);
        this.paths[i].path2d = new Path2D(this.paths[i].path);
        
      }
    }

    
  }


  paint(ctx, fps) {
    for( let i in this.paths ) {
      if( fps.current >= this.paths[i].begin && fps.current < this.paths[i].duration ) {
        //ctx.stroke(this.paths[i].path2d);

        //---- Which method ?
        let delta = this.Transition(fps, this.paths[i]); //0;
        
        let distance = delta * this.paths[i].pathEl.getTotalLength();
        let pt = this.paths[i].pathEl.getPointAtLength(distance);


        
        let tempString = this.paths[i].text, metrics = ctx.measureText(tempString );
        ctx.font = `${this.details.fontSize}px ${this.details.fontFamily}`;
        ctx.fillText(this.paths[i].text, pt.x - (metrics.width/2), pt.y + (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);
        this.Min(pt.x - (metrics.width/2), pt.y - (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);
        this.Max(pt.x + (metrics.width/2), pt.y + (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)/2);

        //this.box(ctx, fps);
      }
    }
    return {min: this.min, max: this.max};
  }
}

